import Sugar from "sugar";
import moment from "moment";
import { FETCH_COLLECTIONS, FETCH_SUPPLIERS } from "../actions/types";
import {browserHistory} from "react-router";

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return (
      typeof value === "number" &&
      isFinite(value) &&
      Math.floor(value) === value
    );
  };
const Util = {
  mapFieldsToMoney(fields, formData) {
    let data = {};

    fields.forEach(field => {
      if (formData[field]) {
        data[field] = this.convertMoneyToDecimal(formData[field]);
      }
    });

    return data;
  },

  mapDecimalToMoney(fields, formData) {
    let data = {};

    fields.forEach(field => {
      if (formData[field]) {
        data[field] = this.convertDecimalToMoney(formData[field]);
      }
    });

    return data;
  },

  mapFieldsToDatabaseDate(fields, formData) {
    let data = {};

    fields.forEach(field => {
      if (formData[field]) {
        data[field] = this.convertToDatabaseDate(formData[field]);
      }
    });

    return data;
  },

  mapFieldsToDatabaseDateClean(fields, formData) {
    let data = {};

    fields.forEach(field => {
      if (formData[field] && formData[field] !== "") {
        data[field] = this.convertToDatabaseDate(formData[field]);
      }
    });

    return data;
  },

  filterDtConfig(dtConfig, name) {
    if (dtConfig) {
      dtConfig = Sugar.Array.filter(dtConfig, function(object) {
        return object.name === name;
      });
      dtConfig = Sugar.Array.first(dtConfig);

      if (!dtConfig) {
        dtConfig = { has_search: false };
        dtConfig[name] = [];
      }

      switch (dtConfig.name) {
        case "collection":
          dtConfig.type = FETCH_COLLECTIONS;
          break;
        case "supplier":
          dtConfig.type = FETCH_SUPPLIERS;
          break;
        default:
      }
    }
    if (!dtConfig) {
      dtConfig = { has_search: false };
      dtConfig[name] = [];
    }

    return dtConfig;
  },
  isEmpty(obj) {
    return obj ? Object.keys(obj).length === 0 : true;
  },
  isUndefined(obj) {
    return "undefined" === typeof obj;
  },
  escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
  },
  replaceAll(str, find, replace) {
    return str.replace(new RegExp(this.escapeRegExp(find), "g"), replace);
  },
  convertMoneyToDecimal(money) {
    if (isNaN(parseFloat(money))) money = "0,00";
    if (Number.isInteger(money) || !isNaN(parseFloat(money))) {
      money += "";
    }
    let amount = Util.replaceAll(money, ".", "");
    return (amount = parseFloat(amount.replace(",", ".")));
  },
  convertDecimalToMoney(money, p) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }
    return money
      .toFixed(p || 2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  },
  convertDecimalToMoney4(money) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 4,
      maximumFractionDigits: 5
    }).format(money).replace("₺", "")
  },
  convertDecimalToMoney4x(money) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 4,
      maximumFractionDigits: 4
    }).format(money).replace("₺", "")
  },
  convertDecimalToMoney8x(money) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 8,
      maximumFractionDigits: 8
    }).format(money).replace("₺", "")
  },
  convertDecimalToMoney5(money) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }

    var currency_symbol = "₺";

    var formattedOutput = new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 0,
      maximumFractionDigits: 5
    });


    return formattedOutput.format(money).replace(currency_symbol, "");
  },convertDecimalToMoney6x(money) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }

    var currency_symbol = "₺";

    var formattedOutput = new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 0,
      maximumFractionDigits: 6
    });


    return formattedOutput.format(money).replace(currency_symbol, "");
  },
  convertDecimalToMoney6(money) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money.toFixed(6));
    }
    return money;
  },
  convertDecimalToMoney7(money, p) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money.toFixed(p || 6));
    }
    var parts = money.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  },
  convertDecimalToMoneyNew(money, precision = 4) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }

    var currency_symbol = "₺";

    var formattedOutput = new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 0,
      maximumFractionDigits: precision
    });

    return formattedOutput.format(money).replace(currency_symbol, "");
  },
  convertDecimalToString(money, fixed) {
    if (!Number.isInteger(money)) {
      money = parseFloat(money);
    }
    return money.toFixed(fixed).replace(".", ",");
  },
  deleteAllExceptNumbers(val) {
    return val.replace(/[^0-9.]/g, "");
  },
  convertToDatabaseDate(date) {
    if (date) return moment(date).format("YYYY-MM-DD");
    else return "";
  },
  formatDate(date) {
    if (date) return moment(date).format("DD-MM-YYYY");
    else return "";
  },
  convertFromDatabaseDate(date) {
    if (date) return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    else return "";
  },
  convertToDatabaseDateTime(date) {
    if (date) return moment(date).format("DD/MM/YYYY HH:mm");
    else return "";
  },
  convertPercentToNumber(percent) {
    return (
      this.convertMoneyToDecimal(percent ? percent.replace("%", "") : "0,00") /
      100
    );
  },
  convertNumberToPercent(number) {
    return "%" + this.convertDecimalToMoney(number ? number * 100 : 0, 3);
  },
  getErrorAsStr(error) {
    let str = "";
    for (var key in error) {
      if (error.hasOwnProperty(key) && error[key] !== "fail") {
        str += error[key] + "\n";
      }
    }
    return str;
  },
  parseInt(string) {
    return isNaN(parseInt(string, 10)) ? 0 : parseInt(string, 10);
  },

  /**
   * a pure function that converts money fields to decimal
   * @param fields
   * @param formData
   * @returns {{}}
   */
  convertMoneyFieldsToDecimal(fields, formData) {
    let newFormData = { ...formData };

    fields.forEach(field => {
      if (newFormData[field] !== undefined) {
        newFormData[field] = Util.convertMoneyToDecimal(newFormData[field]);
      }
    });

    return newFormData;
  },
  companyModules(module_id){
    const storedModules = localStorage.getItem("company_modules");
    const user = JSON.parse(localStorage.getItem('user'));
    const parsedModules = JSON.parse(storedModules);
    if (Array.isArray(parsedModules)) {
      const rt = parsedModules.find(item => item.module_id === module_id && item.company_id === user.company_id);
      return rt ? true : false;
    } else {
      return false;
    }
  },
  getCompanySettings() {
    try {
      return JSON.parse(localStorage.getItem("company_settings") || "{}");
    } catch (e) {
      return {};
    }
  },
  parseWorkingHoursPolicy(rawPolicy) {
    if (!rawPolicy) return null;
    if (typeof rawPolicy === "object") return rawPolicy;
    if (typeof rawPolicy !== "string") return null;
    try {
      return JSON.parse(rawPolicy);
    } catch (e) {
      return null;
    }
  },
  getWorkingHoursPolicyFromSettings(settings) {
    const user = JSON.parse(localStorage.getItem('user'));
    const raw = user.working_hour_json || null;
    const policy = this.parseWorkingHoursPolicy(raw);
    if (policy) return policy;
    return null;
  },
  timeToMinutes(timeStr) {
    if (!timeStr || typeof timeStr !== "string") return null;
    const parts = timeStr.split(":");
    if (parts.length < 2) return null;
    const h = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    if (isNaN(h) || isNaN(m)) return null;
    if (h < 0 || h > 23 || m < 0 || m > 59) return null;
    return h * 60 + m;
  },
  getNowPartsInTimeZone(timeZone, nowDate) {
    const d = nowDate || new Date();
    const tz = timeZone || "Europe/Istanbul";
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      weekday: "short",
    });
    const parts = formatter.formatToParts(d);
    const map = {};
    parts.forEach((p) => {
      if (p.type && p.value) map[p.type] = p.value;
    });
    const weekdayMap = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
    const weekday = weekdayMap[map.weekday] || null;
    const dateStr = map.year && map.month && map.day ? `${map.year}-${map.month}-${map.day}` : null;
    const minutes = this.timeToMinutes(`${map.hour || "00"}:${map.minute || "00"}`);
    return { weekday, dateStr, minutes, timeZone: tz };
  },
  checkWorkingHoursAccess(policy, nowDate) {
    if (!policy || policy.enabled !== true) return { allowed: true };
    const d = nowDate || new Date();
    const jsDay = d.getDay();
    const weekday = jsDay === 0 ? 7 : jsDay;
    const minutes = d.getHours() * 60 + d.getMinutes();
    if (!weekday && weekday !== 0) return { allowed: true };

    const user = (() => {
      try {
        return JSON.parse(localStorage.getItem("user") || "{}");
      } catch (e) {
        return {};
      }
    })();
    //if (policy.excludeOwner === true && user && user.is_owner) return { allowed: true };

    const days = policy.days || {};
    const todayRule = days[weekday] || {};
    const start = this.timeToMinutes(todayRule.start);
    const end = this.timeToMinutes(todayRule.end);

    const prevDay = weekday === 1 ? 7 : weekday - 1;
    const prevRule = days[prevDay] || {};
    const prevStart = this.timeToMinutes(prevRule.start);
    const prevEnd = this.timeToMinutes(prevRule.end);
    const prevEnabled = prevRule && prevRule.enabled === true && prevStart !== null && prevEnd !== null;
    if (prevEnabled && prevEnd <= prevStart && minutes < prevEnd) {
      return { allowed: true };
    }

    if (!todayRule || todayRule.enabled !== true) {
      return { allowed: false, reason: "Çalışma saatleri dışında giriş yapılamaz." };
    }
    if (start === null || end === null) {
      return { allowed: false, reason: "Çalışma saatleri dışında giriş yapılamaz." };
    }

    if (end > start) {
      return minutes >= start && minutes < end
        ? { allowed: true }
        : { allowed: false, reason: "Çalışma saatleri dışında giriş yapılamaz." };
    }
    const allowed = minutes >= start || minutes < end;
    return allowed ? { allowed: true } : { allowed: false, reason: "Çalışma saatleri dışında giriş yapılamaz." };
  },
  backButton(uri){
    if (this && this.props && this.props.router) {
      this.props.router.push(uri);
    }else{
      window.location.assign(uri);
    }
    
  }
};

export default Util;
